import React from 'react'
import { Select, Input  } from 'antd';

const { Option } = Select;
const { TextArea } = Input;
function handleChange(value) {
  console.log(`selected ${value}`);
}

function Employment() {
	
  return (
  <>
    <div className='container'>
	<label class='subtext-2'>Employment status</label>
		<Select defaultValue="select" style={{ width: '100%',height: 50, border: '1px solid #333333', borderRadius: 10, display:'flex', alignItems:'center' }}  bordered={false}onChange={handleChange}>
      <Option value="select">Choose an employment status</Option>
      <Option value="employed">Employed</Option>
      <Option value="unemployed">Unemployed</Option>
	  <Option value="selfemployed">Self Employed</Option>
    </Select>
	
	<br />
    <label class='subtext-2'>Employer name</label>
	<Input placeholder="" style={{ width: '100%', height: 50, border: '1px solid #333333', borderRadius: 10 }} bordered={false} />
	
	<br /><br />
	
	<label class='subtext-2'>Monthly income</label>
		<Select defaultValue="" style={{ width: '100%',height: 50, border: '1px solid #333333', borderRadius: 10, display:'flex', alignItems:'center' }}  bordered={false}onChange={handleChange}>
      <Option value="select">Choose a range</Option>
      <Option value="employed">Employed</Option>
      <Option value="unemployed">Unemployed</Option>
	  <Option value="selfemployed">Self Employed</Option>
    </Select>
	
	<br />
	<label class='subtext-2'>Employer address</label>
	<TextArea
          placeholder=""
          autoSize={{ minRows: 2, maxRows: 6 }} 
		  style={{ width: '100%',height: 50, border: '1px solid #333333', borderRadius: 10, display:'flex', alignItems:'center' }}  bordered={false}
        />
    </div>
	
	</>
  )
}

export default Employment